// WHIT-497: the closed look of a package-search field, so the package and
// hotel tabs look like the flight tab. A flight field is shaded only while
// it is empty (components/Select, components/DatePicker); a package field
// was shaded whatever it held, which read as a blue box around the form.
// Pure (no DOM, no React) so `node --test web/utils/searchFieldLook.test.js`
// can load it.

const OPEN = 'bg-white ring-2 ring-tt-dark-purple';
const FILLED =
  'bg-white ring-1 ring-tt-light-purple hover:ring-2 hover:ring-tt-dark-purple';
const EMPTY =
  'bg-tt-verylight-purple ring-1 ring-transparent hover:ring-2 hover:ring-tt-dark-purple';

const fieldLook = ({ open, filled }) =>
  open ? OPEN : filled ? FILLED : EMPTY;

// The minimum star counts the stars setting offers; 0 is any.
const STAR_OPTIONS = [0, 1, 2, 3, 4, 5];

module.exports = { fieldLook, STAR_OPTIONS };
